import { DEFAULT_NULL } from 'constants/appConstants';

export const getMultiServiceStatus = (
  computeSharingEnabled: string | boolean,
) => {
  if (computeSharingEnabled === 'null') {
    return DEFAULT_NULL;
  } else {
    return ['true', true].includes(computeSharingEnabled)
      ? 'Enabled'
      : 'Disabled';
  }
};
export const getMultiDiskStatus = (multiDisk) => {
  if (multiDisk === null) {
    return DEFAULT_NULL;
  } else {
    return multiDisk ? 'Enabled' : 'Disabled';
  }
};
